import RequireJs from '@helpers/RequireJs';
import RequireCss from '@helpers/RequireCss';
import { FilterDrawerModel } from '@_types/types';
import { getModifiers } from '@helpers/functions';
import Drawer from '@molecules/drawer/Drawer';
import Accordion from '@organisms/accordion/Accordion';

const FilterDrawer = (model: FilterDrawerModel) => {
  const styleModifier = getModifiers(model, 'kf-o-filter-drawer');
  const { subHeading, heading, subButton, closeIconButton, mainButton, searchId, criteria, id, source, title, excludeJs, cssPath } = model;

  return (
    <div className={styleModifier} data-id={id} data-search-id={searchId} data-source={source}>
      <form aria-label={title} className="kf-o-filter-drawer__form" title={title}>
        <Drawer closeIconButton={closeIconButton} mainButton={mainButton} subButton={subButton}>
          <div className="kf-o-filter-drawer__top">
            <p className="kf-o-filter-drawer__heading">{heading}</p>
            <p className="kf-o-filter-drawer__subheading">{subHeading}</p>
          </div>

          <div aria-label="Filter Criteria" role="group">
            {criteria && <Accordion {...criteria} />}
          </div>
        </Drawer>
      </form>
      {!excludeJs && <RequireJs defer path={'filter-drawer'} />}

      <RequireCss path={cssPath ?? 'b-filter-drawer'} />
    </div>
  );
};

export default FilterDrawer;
